import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSliderModule} from '@angular/material/slider';
import {MatTableModule} from '@angular/material/table';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {WidgetDirective} from './widget.directive';
import {DetailLotsComponent} from './detail-lots/detail-lots.component';
import {PopulationComponent} from './population/population.component';
import {PyramideAgesComponent} from './pyramide-ages/pyramide-ages.component';
import {LoyerMoyenComponent} from './loyer-moyen/loyer-moyen.component';
import {VilleLienComponent} from './ville-lien/ville-lien.component';
import {RepartitionComponent} from './repartition/repartition.component';
import {TensiometreComponent} from './tensiometre/tensiometre.component';
import {CommoditeVilleComponent} from './commodite-ville/commodite-ville.component';
import {TaxeFonciereComponent} from './taxe-fonciere/taxe-fonciere.component';
import {NotesComponent} from './notes/notes.component';
import {PriceEvolComponent} from './price-evol/price-evol.component';
import {DescriptifComponent} from './descriptif/descriptif.component';
import {PhotosComponent} from './photos/photos.component';
import {Nl2BrPipeModule} from 'nl2br-pipe';
import {ContactComponent} from './contact/contact.component';
import {PartnerInterestComponent} from './partner-interest/partner-interest.component';
import {InformationGeneralComponent} from './information-general/information-general.component';
import {SimulateurTravauxComponent} from './simulateur-travaux/simulateur-travaux.component';
import {RevenusComponent} from './revenus/revenus.component';
import {AchatComponent} from './achat/achat.component';
import {ChargesComponent} from './charges/charges.component';
import {FinancementComponent} from './financement/financement.component';
import {ConfigImpotsComponent} from './config-impots/config-impots.component';
import {PrixMoyenComponent} from './prix-moyen/prix-moyen.component';
import {RendementTypologieComponent} from './rendement-typologie/rendement-typologie.component';
import {PrixMoyenGraphComponent} from './prix-moyen-graph/prix-moyen-graph.component';
import {RepartitionInoutComponent} from './repartition-inout/repartition-inout.component';
import {RecapAchatComponent} from './recap-achat/recap-achat.component';
import {RecapLoyerComponent} from './recap-loyer/recap-loyer.component';
import {RecapCreditComponent} from './recap-credit/recap-credit.component';
import {RecapChargeComponent} from './recap-charge/recap-charge.component';
import {RecapKpiComponent} from './recap-kpi/recap-kpi.component';
import {NgxEchartsModule} from 'ngx-echarts';
import {EvolPrixImmoComponent} from './evol-prix-immo/evol-prix-immo.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {EtudiantComponent} from './etudiant/etudiant.component';
import {MenagesComponent} from './menages/menages.component';
import {EntreprisesComponent} from './entreprises/entreprises.component';
import {LogementsComponent} from './logements/logements.component';
import {CommercesComponent} from './commerces/commerces.component';
import {ServicesVilleComponent} from './services-ville/services-ville.component';
import {TourismeComponent} from './tourisme/tourisme.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';
import {DirectiveModule} from '~/app/shared/directives/directive.module';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {ConfigRendementToolsComponent} from './config-rendement-tools/config-rendement-tools.component';
import {ConfigCityToolsComponent} from './config-city-tools/config-city-tools.component';
import {FavoriteModule} from '@components/favorite/favorite.module';
import {SimulatorComponent} from './simulator/simulator.component';
import {ConfigProjectToolsComponent} from './config-project-tools/config-project-tools.component';
import {JoyrideModule} from 'ngx-joyride';
import {ConfigProjectUrlComponent} from './config-project-url/config-project-url.component';
import {ConfigDpeToolsComponent} from './config-dpe-tools/config-dpe-tools.component';
import {ConfigEmpruntToolsComponent} from './config-emprunt-tools/config-emprunt-tools.component';
import {PopupComponent} from './photos/popup/popup.component';
import {CityMapComponent} from './city-map/city-map.component';
import {PipeModule} from '~/app/shared/pipe/pipe.module';
import {ConfigImpotToolsComponent} from './config-impot-tools/config-impot-tools.component';
import {PopulationActivityComponent} from './population-activity/population-activity.component';
import {RouterModule} from '@angular/router';
import {VerifDataComponent} from './verif-data/verif-data.component';
import {LocalisationComponent} from './localisation/localisation.component';
import {MessagesModule} from '@components/messages/messages.module';

@NgModule({
    declarations: [
        DetailLotsComponent,
        WidgetDirective,
        PopulationComponent,
        PyramideAgesComponent,
        LoyerMoyenComponent,
        RendementTypologieComponent,
        VilleLienComponent,
        RepartitionComponent,
        TensiometreComponent,
        CommoditeVilleComponent,
        TaxeFonciereComponent,
        NotesComponent,
        PriceEvolComponent,
        DescriptifComponent,
        PhotosComponent,
        ContactComponent,
        PartnerInterestComponent,
        InformationGeneralComponent,
        SimulateurTravauxComponent,
        RevenusComponent,
        AchatComponent,
        ChargesComponent,
        FinancementComponent,
        ConfigImpotsComponent,
        PrixMoyenComponent,
        PrixMoyenGraphComponent,
        RepartitionInoutComponent,
        RecapAchatComponent,
        RecapLoyerComponent,
        RecapCreditComponent,
        RecapChargeComponent,
        RecapKpiComponent,
        EvolPrixImmoComponent,
        ConfigCityToolsComponent,
        ConfigRendementToolsComponent,
        EtudiantComponent,
        MenagesComponent,
        EntreprisesComponent,
        LogementsComponent,
        CommercesComponent,
        ServicesVilleComponent,
        TourismeComponent,
        ConfigRendementToolsComponent,
        ConfigImpotToolsComponent,
        ConfigCityToolsComponent,
        SimulatorComponent,
        ConfigProjectToolsComponent,
        ConfigProjectUrlComponent,
        ConfigDpeToolsComponent,
        ConfigEmpruntToolsComponent,
        PopupComponent,
        CityMapComponent,
        PopulationActivityComponent,
        VerifDataComponent,
        LocalisationComponent,
    ],
    exports: [
        DetailLotsComponent,
        WidgetDirective,
        PopulationComponent,
        PyramideAgesComponent,
        LoyerMoyenComponent,
        RendementTypologieComponent,
        VilleLienComponent,
        RepartitionComponent,
        TensiometreComponent,
        CommoditeVilleComponent,
        TaxeFonciereComponent,
        NotesComponent,
        PriceEvolComponent,
        DescriptifComponent,
        PhotosComponent,
        ContactComponent,
        PartnerInterestComponent,
        InformationGeneralComponent,
        SimulateurTravauxComponent,
        RevenusComponent,
        AchatComponent,
        ChargesComponent,
        FinancementComponent,
        ConfigImpotsComponent,
        PrixMoyenComponent,
        PrixMoyenGraphComponent,
        RecapAchatComponent,
        RecapLoyerComponent,
        RecapCreditComponent,
        RecapChargeComponent,
        RecapKpiComponent,
        EvolPrixImmoComponent,
        ConfigCityToolsComponent,
        ConfigRendementToolsComponent,
        EtudiantComponent,
        MenagesComponent,
        EntreprisesComponent,
        LogementsComponent,
        CommercesComponent,
        ServicesVilleComponent,
        TourismeComponent,
        SimulatorComponent,
        ConfigProjectToolsComponent,
        ConfigProjectUrlComponent,
        ConfigDpeToolsComponent,
        ConfigEmpruntToolsComponent,
        VerifDataComponent,
        LocalisationComponent,
        PopulationActivityComponent,
    ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        FormsModule,
        MatButtonModule,
        MatSelectModule,
        MatInputModule,
        Nl2BrPipeModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatTableModule,
        NgxEchartsModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        DirectiveModule,
        MessagesModule,
        MatProgressBarModule,
        DragDropModule,
        FavoriteModule,
        JoyrideModule,
        PipeModule,
        RouterModule,
    ]
})
export class WidgetModule {
}
